<app-main-layout>
  <section class="workspace-page" *ngIf="pageData | async as data" aria-labelledby="workspace-title">
    <div class="workspace-hero">
      <div>
        <span class="eyebrow">{{ data.eyebrow }}</span>
        <h1 id="workspace-title">{{ data.title }}</h1>
        <p>{{ data.description }}</p>
      </div>
    </div>

    <div class="workspace-grid">
      <article class="workspace-metric" *ngFor="let metric of data.metrics" [class]="'workspace-metric tone-' + metric.tone">
        <span>{{ metric.label }}</span>
        <strong>{{ metric.value }}</strong>
      </article>
    </div>

    <article class="workspace-panel">
      <div class="panel-heading">
        <div>
          <span class="eyebrow">Рабочая область</span>
          <h2>{{ data.title }}</h2>
        </div>
      </div>

      <div class="placeholder-grid">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </article>
  </section>
</app-main-layout>
